import { createContext } from 'react';

type ContextProps = {
  clientTimeZone: string;
  daysBack: string;
  listingAlias?: string;
  startDate?: string;
};

export const MultiFamilyLeadsPageContext = createContext<ContextProps>({} as ContextProps);
export const MultiFamilyLeadsPageContextProvider = MultiFamilyLeadsPageContext.Provider;
